import { useHistory } from 'react-router-dom';
import Parser from 'html-react-parser';
import l from '../../../lang';
import { Routes } from '../../../config/routes';
import TopDashboardSection from '../../common/top-dashboard-section';
import Card from '../../common/card';
import CardInfo from '../../common/card-info';
import Popup from '../../common/popup';
import AlertMessages from '../alert-messages';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info-unfilled.svg';
import { ReactComponent as ReportsIcon } from '../../../assets/icons/reports.svg';
import { ReactComponent as TransactionsIcon } from '../../../assets/icons/transactions.svg';
import { ReactComponent as RefundsIcon } from '../../../assets/icons/refunds.svg';
import { ReactComponent as SettlementIcon } from '../../../assets/icons/settlement.svg';
import { ReactComponent as CardIcon } from '../../../assets/icons/card.svg';
import './styles.scss';

interface MovementOption {
  id: string;
  labelKey: string;
  tooltipKey: string;
  route: string;
  icon: React.ReactNode;
}

const Movements = () => {
  const history = useHistory();

  const options: MovementOption[] = [
    {
      id: 'transactions',
      labelKey: 'menu.item.TRANSACTIONS',
      tooltipKey: 'transactions.subheadline',
      route: Routes.TRANSACTIONS,
      icon: <TransactionsIcon className="movements-hub__icon movements-hub__icon--svg" aria-hidden />,
    },
    {
      id: 'refunds',
      labelKey: 'menu.item.REFUNDS',
      tooltipKey: 'menu.item.REFUNDS.desc',
      route: Routes.REFUNDS,
      icon: <RefundsIcon className="movements-hub__icon movements-hub__icon--svg" aria-hidden />,
    },
    {
      id: 'settlements',
      labelKey: 'menu.item.SETTLEMENTS',
      tooltipKey: 'menu.item.SETTLEMENTS.desc',
      route: Routes.SETTLEMENTS,
      icon: <SettlementIcon className="movements-hub__icon movements-hub__icon--svg" aria-hidden />,
    },
    {
      id: 'chargebacks',
      labelKey: 'menu.item.CHARGEBACKS',
      tooltipKey: 'chargebacks.subheadline',
      route: Routes.CHARGEBACKS,
      icon: <CardIcon className="movements-hub__icon movements-hub__icon--svg" aria-hidden />,
    },
    {
      id: 'reports',
      labelKey: 'menu.item.REPORTS',
      tooltipKey: 'reports.description',
      route: Routes.REPORTS,
      icon: <ReportsIcon className="movements-hub__icon movements-hub__icon--svg" aria-hidden />,
    },
  ];

  return (
    <div className="movements-hub">
      <TopDashboardSection title={l('menu.item.SIDEBAR_MOVIMIENTOS')} subtitle={l('movements.subheadline')} />
      <AlertMessages />
      <Card className="movements-hub__card">
        <div className="movements-hub__grid" role="list">
          {options.map(option => (
            <CardInfo key={option.id} bottomElement={<div className="movements-hub__accent-line" />}>
              <button
                type="button"
                className="movements-hub__item"
                role="listitem"
                onClick={() => history.push(option.route)}
              >
                <div
                  className="movements-hub__info"
                  onClick={e => e.stopPropagation()}
                  onKeyDown={e => e.stopPropagation()}
                >
                  <Popup
                    text={Parser(l(option.tooltipKey))}
                    icon={<InfoIcon className="movements-hub__info-icon" aria-hidden />}
                  />
                </div>
                <div className="movements-hub__icon-wrap">{option.icon}</div>
                <div className="movements-hub__label">{l(option.labelKey)}</div>
              </button>
            </CardInfo>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default Movements;
